import axios from 'axios';

export const api = 'http://localhost:8000/api/';


